export default {
  home: 'Inicio',
  studyPlan: 'Plan de Estudio',
  curricularMesh: 'Malla Curricular',
  matterDescription: 'Descripción de Asignatura',
  evaluations: 'Evaluaciones',
  learningExperiences: 'Experiencias de Aprendizaje',
}
